import Chartbeat from './Chartbeat'

export default Chartbeat
